// Teacher workspace appearance (D-163): follow the system, or always dark / always light.
// Pure helpers only, so the rules are unit-tested without a DOM.

export type AppearanceMode = "system" | "dark" | "light";
export const APPEARANCE_MODES: readonly AppearanceMode[] = ["system", "dark", "light"];
/** Per-device choice in localStorage (not account data; see D-163 for the migration-free reason). */
export const APPEARANCE_KEY = "classmori-appearance";
/** D-160 stored the quiet challenge's own night switch here; it is folded into the global choice once. */
export const LEGACY_QUIET_NIGHT_KEY = "classmori-quiet-night";

export function parseAppearance(value: unknown): AppearanceMode {
  return value === "dark" || value === "light" ? value : "system";
}

export function resolveAppearance(mode: AppearanceMode, systemDark: boolean): "dark" | "light" {
  return mode === "system" ? (systemDark ? "dark" : "light") : mode;
}

/**
 * The stored choice, migrating D-160's quiet-challenge night switch: a teacher who had turned it on
 * keeps a dark screen (now the whole workspace), and the old key is dropped either way.
 */
export function readStoredAppearance(storage: Pick<Storage, "getItem" | "setItem" | "removeItem">): AppearanceMode {
  const stored = storage.getItem(APPEARANCE_KEY);
  const legacy = storage.getItem(LEGACY_QUIET_NIGHT_KEY);
  if (legacy !== null) {
    storage.removeItem(LEGACY_QUIET_NIGHT_KEY);
    if (stored === null && legacy === "1") { storage.setItem(APPEARANCE_KEY, "dark"); return "dark"; }
  }
  return parseAppearance(stored);
}

/** One button (the quiet challenge, a collapsed sidebar) flips what is on screen now, as an explicit choice. */
export function toggledAppearance(effective: "dark" | "light"): AppearanceMode {
  return effective === "dark" ? "light" : "dark";
}
